import { productionReducer } from "../../redux/ProductionReducer/ProductionReducer";
import { wizardStore } from "../../redux/WizardReducer/WizardReducer";
import { appContextStore } from "../../../common/redux/appContext";
import { ISaveAppStateRequest } from "../types";

const buildStateObj = (): ISaveAppStateRequest => ({
	applicationState: {
		wizardReducer: { ...wizardStore.getState() },
		productionReducer: { ...productionReducer.getState() },
		membershipApplication: {
			...appContextStore.getState().membershipApplication,
		},
	},
});

export default buildStateObj;
